import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import CashCoinIcon from 'assets/icons/cash-coin.svg';
import ClockHistoryIcon from 'assets/icons/clock-history.svg';
import GraphUpIcon from 'assets/icons/graph-up.svg';
import { PageTitle } from 'presentation/components/PageTitle';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { CardComponent } from './components/Card';
import { Mock } from './models/Mock';

interface props {
    userUseCase: UserUseCaseInterface;
}
const MG00901Page = ({ userUseCase }: props) => {
    const mock: Mock[] = [
        {
            title: '売却シミュレーション',
            description: ['売却したい物件の購入当初の諸条件を入力', 'し、現在の売却想定価格を入力することに', 'よって、損益をシミュレーションできます。'],
            image: <img alt="" style={{ width: 32, height: 32 }} src={CashCoinIcon} />,
            redirect: PRIVATE_ROUTES.SUB.CU_010_01,
        },
        {
            title: 'キャッシュフローシミュレーション',
            description: ['物件の収入や支出を入力し、ローン条件を', '考慮して、現在のキャッシュフローを算出', 'します。これにより、投資物件の収益性を', 'シミュレーションできます。'],
            image: <img alt="" style={{ width: 32, height: 32 }} src={CashCoinIcon} />,
            redirect: PRIVATE_ROUTES.SUB.CU_051_01,
        },
        {
            title: '借入金シミュレーション',
            description: ['現在の年収と既存借入額から、おおよその', '融資限度額をシミュレーションすることが', 'できます。'],
            image: <img alt="" style={{ width: 32, height: 32 }} src={CashCoinIcon} />,
            redirect: PRIVATE_ROUTES.SUB.CU_052_01,
        },
        // {
        //     title: '損益分岐シミュレーション',
        //     description: ['説明文が入ります説明文が入ります説明文', 'が入ります説明文が入ります'],
        //     image: <img alt="" style={{ width: 32, height: 32 }} src={GraphUpIcon} />,
        //     redirect: PRIVATE_ROUTES.SUB.CU_053_01,
        // },
        {
            title: 'シミュレーション履歴',
            description: ['過去に実行したシミュレーションの結果を', '確認することができます。'],
            image: <img alt="" style={{ width: 32, height: 32 }} src={ClockHistoryIcon} />,
            redirect: PRIVATE_ROUTES.SUB.CU_059_01,
        },
    ];

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-050-01-container"
        >
            <PageTitle title="シミュレーション" />
            <section
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                }}
            >
                <div className="grid-container">
                    {mock.map((element: Mock, index: number) => (
                        <div key={index} tabIndex={index}>
                            <CardComponent {...element} />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default MG00901Page;
